import { useSelector } from 'react-redux';
import { AppBase } from '../../../../../../shared/frontend/components/appBase';
import CookieFooter from '../../../../../../shared/frontend/components/presentational/cookieFooter';
import { AuthBar } from '../container/authBar';
import LoadableQueueModalContainer from '../container/loadableQueueModalContainer';
import MainNavBar from '../container/mainNavBar';
import SiteFooter from './siteFooter';

const App = (props: any) => {
  const queueModalIsOpen = useSelector((state: any) => state.queueModal.isOpen);

  return (
    <AppBase
      {...props}
      authBarComponent={AuthBar}
      navBarComponent={MainNavBar}
      siteFooterComponent={SiteFooter}
      cookieFooterComponent={CookieFooter}
      preContentComponents={queueModalIsOpen ? <LoadableQueueModalContainer /> : null}
    />
  );
};

export default App;
